import React from "react";
import TopField from "./component/TopField/TopField.view";
import StackedBarChart from "./component/StackedBarChart/StackedBarChart.view";
import GroupedBarChart from "./component/GroupedBarChart/GroupedBarChart.view";
import styles from "./Style.module.css";
import CityEnrollmentChart from "./component/CityChart/CityChart";
import TrendChart from "./component/TrendChart/TrendChart";
import EnrolementMode from "./component/EnrolmentMode/EnrolmentMode";
import MapChart from "./component/IndiaMap/IndiaMap";
import useProgramDashboard from "./ProgramDashboard.hook";
import { Typography } from "@mui/material";
import DialogWrapper from "./component/DialogWrapper/DialogWrapper.view";

const customColors = {
  TAKEN: "#F29E2F",
  TAKEN_LATE: "#6796F5",
  MISSED: "#F55D5D",
  SKIPPED: "#16C59B",
};

const defaultColors = {
  enrollment: "#f4a621",
  dropout: "#1f78c1",
};
const doctorColor = {
  enrollment: "#17BCD5",
  dropout: "#6D54E6",
};

const medicineColor = {
  refill_count: "#6796F5",
  consumption_count: "#E26D14",
};

function ProgramDashboard() {
  const {
    form,
    changeTextData,
    rewardData,
    cityData,
    dropData,
    cityWiseData,
    doctorWiseData,
    handleDetail,
    medicineRefill,
    medReminder,
    enrollmentData,
    mapData,
    groupedData,
    handleReset,
    expandedView,
    handleExpand,
    setExpandedView,
    handleProgramEnrollExport,
    handleProgramTrendExport,
    handleDoctorWiseData,
  } = useProgramDashboard({});

  return (
    <div className={styles.dashboardContainer}>
      <TopField
        form={form}
        changeTextData={changeTextData}
        handleReset={handleReset}
      />
      <div className={styles.statsContainer}>
        <div className={styles.statCard}>
          <strong style={{ color: "#0080C1" }}>Total Patients</strong> <br />{" "}
          {rewardData?.total_patients ?? "-"}
        </div>
        <div className={styles.statCard}>
          <strong style={{ color: "#0080C1" }}>Active Patients</strong> <br />{" "}
          {rewardData?.active_patients ?? "-"}
        </div>
        <div className={styles.statCard}>
          <strong style={{ color: "#0080C1" }}>Dropouts</strong> <br />{" "}
          {rewardData?.dropout_patients ?? "-"}
        </div>{" "}
        <div className={styles.statCard}>
          <strong style={{ color: "#0080C1" }}>Adherence</strong> <br />{" "}
          {rewardData?.adherence ?? "-"}
        </div>{" "}
        <div className={styles.statCard}>
          <strong style={{ color: "#0080C1" }}>Associated Doctors</strong>{" "}
          <br /> {rewardData?.associated_doctors ?? "-"}
        </div>
      </div>
      <div className={styles.formFlex}>
        <div className={styles.mapWrap}>
          <MapChart data={mapData} title={"Distribution Map"} isImgDownload />
        </div>
        <div className={styles.cityWrap}>
          <EnrolementMode enrollData={enrollmentData} isImgDownload />
        </div>
      </div>
      {/* <div className={styles.formFlex}> */}
      <div className={styles.formGrp21FullSack}>
        <CityEnrollmentChart
          data={cityData}
          isImgDownload
          isExpand
          downloadTitle="City Wise Enrollment Download"
          isExport
          handleExport={handleProgramEnrollExport}
          onExpand={() =>
            handleExpand(
              "City Wise Enrollment",
              <CityEnrollmentChart
                data={cityData}
                colors={doctorColor}
                isExpand={false}
                isImgDownload={false}
              />
            )
          }
        />
      </div>
      <div className={styles.formGrp21FullSack}>
        <GroupedBarChart
          className={styles.enrollContainer}
          title="Enrollment vs Dropout"
          data={dropData}
          dataKey="label"
          colors={defaultColors}
          sx={{ backgroundColor: "#f5f5f5" }}
          isImgDownload
          isExpand
          isExport
          handleExport={handleProgramTrendExport}
          downloadTitle="Enrollment Dropout Download"
          onExpand={() =>
            handleExpand(
              "Enrollment vs Dropout",
              <GroupedBarChart
                className={styles.enrollContainer}
                title="Enrollment vs Dropout"
                data={dropData}
                dataKey="label"
                sx={{ backgroundColor: "#f5f5f5" }}
                colors={defaultColors}
                isExpand={false}
                isImgDownload={false}
              />
            )
          }
        />
      </div>
      {/* </div> */}
      <TrendChart
        trendData={groupedData}
        title="Trend"
        downloadTitle="Trend Download"
        isExport
        handleExport={handleProgramEnrollExport}
        dataSet={[
          {
            label: "Enrollment",
            data: groupedData?.enrollment || [],
            borderColor: "#E26D14",
            borderWidth: 1,
            pointBackgroundColor: "#E26D14",
            pointRadius: 2,
            fill: false,
          },
          {
            label: "Dropout",
            data: groupedData?.dropout || [],
            borderColor: "#004DC1",
            borderWidth: 1,
            pointBackgroundColor: "#004DC1",
            pointRadius: 2,
            fill: false,
          },
        ]}
        isImgDownload
        isExpand
        onExpand={() =>
          handleExpand(
            "Trend",
            <TrendChart
              trendData={groupedData}
              title="Trend"
              dataSet={[
                {
                  label: "Enrollment",
                  data: groupedData?.enrollment || [],
                  borderColor: "#E26D14",
                  borderWidth: 1,
                  pointBackgroundColor: "#E26D14",
                  pointRadius: 2,
                  fill: false,
                },
                {
                  label: "Dropout",
                  data: groupedData?.dropout || [],
                  borderColor: "#004DC1",
                  borderWidth: 1,
                  pointBackgroundColor: "#004DC1",
                  pointRadius: 2,
                  fill: false,
                },
              ]}
              isImgDownload={false}
              isExpand={false}
            />
          )
        }
      />
      <div className="formFlex">
        <GroupedBarChart
          title="City Wise Data"
          data={cityWiseData}
          dataKey="name"
          colors={defaultColors}
          sx={{ backgroundColor: "#f5f5f5" }}
          isImgDownload
          isExpand
          isExport
          downloadTitle="City Wise Download"
          handleExport={handleProgramEnrollExport}
          onExpand={() =>
            handleExpand(
              "City Wise Data",
              <GroupedBarChart
                title="City Wise Data"
                data={cityWiseData}
                dataKey="name"
                sx={{ backgroundColor: "#f5f5f5" }}
                colors={defaultColors}
                isExpand={false}
                isImgDownload={false}
              />
            )
          }
        />
      </div>
      <div className="formFlex">
        <GroupedBarChart
          title="Doctor Wise Data"
          // data={defaultData}
          data={doctorWiseData}
          dataKey="name"
          colors={doctorColor}
          sx={{ backgroundColor: "#f5f5f5" }}
          isImgDownload
          isExpand
          isExport
          downloadTitle="Doctor wise Download"
          handleExport={handleDoctorWiseData}
          onExpand={() =>
            handleExpand(
              "Doctor Wise Data",
              <GroupedBarChart
                title="Doctor Wise Data"
                data={doctorWiseData}
                dataKey="name"
                sx={{ backgroundColor: "#f5f5f5" }}
                colors={doctorColor}
                isExpand={false}
                isImgDownload={false}
              />
            )
          }
        />
      </div>

      {/* <div className={styles.formFlex}> */}
      <div className={styles.formGrp21FullSack}>
        <GroupedBarChart
          title="Medicine Consumption and Refills"
          data={medicineRefill}
          dataKey="label"
          colors={medicineColor}
          sx={{ backgroundColor: "#f5f5f5" }}
          height={400}
          isExpand
          isImgDownload
          onExpand={() =>
            handleExpand(
              "Medicine Consumption and Refills",
              <GroupedBarChart
                title="Medicine Consumption and Refills"
                data={medicineRefill}
                dataKey="label"
                sx={{ backgroundColor: "#f5f5f5" }}
                colors={medicineColor}
                isExpand={false}
                isImgDownload={false}
              />
            )
          }
        />
      </div>
      <div className={styles.formGrp21FullSack}>
        <StackedBarChart
          title="Medicine Adherence"
          data={medReminder}
          dataKey="label"
          colors={customColors}
          sx={{ backgroundColor: "#f5f5f5" }}
          height={400}
          isImgDownload
          isExpand
          isExport
          handleExport={handleProgramTrendExport}
          downloadTitle="Medicine Adherence Download"
          onExpand={() =>
            handleExpand(
              "Medicine Adherence",
              <StackedBarChart
                title="Medicine Adherence"
                data={medReminder}
                dataKey="label"
                sx={{ backgroundColor: "#f5f5f5" }}
                colors={customColors}
                isExpand={false}
                isImgDownload={false}
              />
            )
          }
        />
      </div>
      {/* </div> */}
      <DialogWrapper
        open={expandedView.open}
        onClose={() =>
          setExpandedView({ open: false, title: "", content: null })
        }
        title={expandedView.title}
      >
        {expandedView.content}
      </DialogWrapper>
    </div>
  );
}

export default ProgramDashboard;
